export default "__VITE_ASSET__BnLIiUfZ__"